import React from 'react';
import '../../../../assets/css/components/customer/services/servicecards/ServiceCards.css';

const ServiceCard = ({ item, index, onClick, className = '' }) => {
  return (
    <div
      className={`sp-card ${className}`}
      style={{ animationDelay: `${index * 0.04}s` }}
      onClick={() => onClick(item)}
    >
      <div className="sp-card__img-wrap">
        <img src={item.image} alt={item.name} className="sp-card__img" />
        <div className="sp-card__img-overlay" />
      </div>

      <div className="sp-card__body">
        <h3 className="sp-card__name">{item.name}</h3>
        <p className="sp-card__desc">
          {item.description}
        </p>
      </div>
    </div>
  );
};

export default ServiceCard;